import { ICON_HEIGHT_16, IconSpinnerOverlay, IconWithTooltip } from '../../Icon'

import * as styles from './ButtonIcon.module.css'

function ButtonIcon({
  Icon,
  className = styles.icon,
  height,
  isLoading,
  tooltip,
  ...restProps
}) {
  return isLoading ? (
    <IconSpinnerOverlay className={className} size={ICON_HEIGHT_16} />
  ) : (
    <IconWithTooltip
      {...restProps}
      Icon={Icon}
      className={className}
      size={height}
      tooltip={tooltip}
    />
  )
}

export default ButtonIcon
